export default __webpack_public_path__ + "static/media/PhysicalDescriptions_11.b5a27d3a.png";